import { POST } from './apiHandler';
import { API_BASE_URL } from 'src/globals';
import { REQUEST_LOGOUT } from './routes';
import { APIResponseType } from 'src/Library/Types';

export const logoutRequest = async (): Promise<APIResponseType<undefined>> => {
  return POST(`${API_BASE_URL}${REQUEST_LOGOUT}`, {});
};
